import React from "react";
import { AppBar, Button, Divider, Grid, Container, Toolbar, Typography, Box } from "@material-ui/core";
import PropertySelection from "../Helpers/PropertySelection";
import LinkHelper from "../Helpers/Link";
import LogOutButton from "../Helpers/LogOutButton";
import Logo from "../Helpers/Logo";
import './header.css'

const Header = ({ loggedIn, landlord, admin, subRoute, routes, index, sticky }) => {
    return (
        <AppBar color="transparent" elevation={0} position={sticky ? "sticky" : "static"} style={{ backgroundColor: 'rgba(255, 255, 255, 0.9)' }}>
            <Container maxWidth="xl">
                <div className='header-logo-container'>
                    <Toolbar disableGutters>
                        <Logo link black />
                        <Box sx={{ flexGrow: 1, display: { xs: 'flex', md: 'flex' }, justifyContent: 'flex-end', fontSize: '24px' }}>
                            {admin ? <>
                                <Button style={{ color: '#060825' }} underline="none" href='/admin' >Admin</Button>
                                <LogOutButton style={{ color: '#060825' }} />
                            </>
                                : routes ? <>
                                    {(landlord && subRoute !== "announcements") && <PropertySelection />}
                                    {routes.filter(r => !r.hidden).map((r, i) => {
                                        return (
                                            <LinkHelper
                                                key={i}
                                                to={`/user/${r.name}`}
                                                styleName="User-link"
                                                component="div"
                                            >
                                                <div className={"User-navigation-link" + (i === index ? " User-navigation-link-selected" : "")}>
                                                    {r.title}
                                                </div>
                                            </LinkHelper>
                                        );
                                    })}
                                    <LogOutButton style={{ color: '#060825' }} />
                                </>
                                    : loggedIn ?
                                        <>
                                            <Button style={{ color: '#060825' }} underline="none" href='/user' >Matches</Button>
                                            <LogOutButton style={{ color: '#060825' }} />
                                        </>
                                        : <>
                                            <Button style={{ color: '#060825', fontWeight: 'bold' }} underline="none" href='/signup/tenant/0' >Tenant</Button>
                                            <Button style={{ color: '#060825', fontWeight: 'bold' }} underline="none" href='/signup/landlord/' >Lessor</Button>
                                            <Button style={{ color: '#060825', fontWeight: 'bold' }} underline="none" href='/login' >Log in</Button>
                                            {/* <Button variant="contained" color="primary" style={{ color: 'white', marginLeft: '16px', padding: '6px 24px', borderRadius: '4px' }} underline="none" href='/signup/landlord/' >List a Space</Button> */}
                                        </>

                            }
                        </Box>
                    </Toolbar>
                </div>
            </Container>
        </AppBar>
    )
}

export default Header;
